module.exports = "<symbol id=\"thebestco-uikit-svg-Right12\" viewBox=\"0 0 12 12\"><path d=\"M3.41 0L2 1.41L6.58 6L2 10.59L3.41 12L9.41 6L3.41 0Z\"/></symbol>";